import React from 'react';
import { Icon } from '@tanium/react-graphics';
import { css } from '@tanium/react-emotion';
import { HEX_7F869D, HEX_FFFFFF } from '@tanium/colors';

type IsCurrentType = boolean;
type IconType = string | Icon;

interface SideNavIconProps {
  isCurrent: IsCurrentType;
  icon: IconType | undefined;
  size: number;
}

const iconStyles = css({ display: 'block' });
const SideNavIconFill = () => HEX_7F869D;
const SideNavIconFillCurrent = () => HEX_FFFFFF;

const IconComponent = ({
  icon: IconProp,
  isCurrent,
  size,
}: {
  icon?: IconType;
  isCurrent: IsCurrentType;
  size: number;
}) => {
  if (IconProp === undefined) {
    return null;
  }

  const commonProps = {
    height: size,
    width: size,
    color: isCurrent ? SideNavIconFillCurrent() : SideNavIconFill(),
    className: iconStyles,
  };

  return <IconProp {...commonProps} />;
};

export const SideNavIcon = React.memo(({ isCurrent, icon: IconProp, size }: SideNavIconProps) => (
  <IconComponent icon={IconProp} isCurrent={isCurrent} size={size} />
));
